import { useState, useEffect } from "react";
import Select from "../../../components/select";
import arrow from "../../../assets/svg-icons/blueArrow.svg";
import close from "../../../assets/svg-icons/closeBrand.svg";
import { Link, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { useRouterList } from "../layout/resuableEffect";
import { FormatDate, formatMonthYear } from "../../../hooks/constants";
import { useFormik } from "formik";
import * as Yup from "yup";
import Input from "../../../components/input";
import Button from "../../../components/button";
import TextArea from "../../../components/textArea";
import PaymentModal from "../../../components/paymentModal";
import useZoneUnitPrices from "../../../hooks/useZoneUnitPrices";
import { toast } from "react-toastify";
import {
  createProjectRouters,
  projectRouterList,
  updateProjectRouter,
  deleteProjectRouter,
} from "../../../hooks/local/userReducer";
import Modal from "../../../components/modal";
import usePartnerNavigation from "../../../hooks/usePartnerNavigation";

const Routers = () => {
  document.title = "Routers - Cloudvantage";

  const dispatch = useDispatch();
  const { navigate, generatePartnerUrl } = usePartnerNavigation();

  const [searchText, setSearchText] = useState("");
  const projectId = useSelector((state) => state.user.selectedProject).id;

  const currency = useSelector((state) => state.user.currency);
  const [currencyPTag, setCurrencyPTag] = useState("");
  const [routerModal, setRouterModal] = useState(false);
  const [manageRouterModal, setManageRouterModal] = useState(false);
  const [editRouterModal, setEditRouterModal] = useState(false);
  const [routerDetailsModal, setRouterDetailsModal] = useState(false);
  const [selectedRouter, setSelectedRouter] = useState(null);
  const [deleteRouterModal, setDeleteRouterModal] = useState(false);
  const {
  getUnitPrice,
  loading: unitPriceLoading,
} = useZoneUnitPrices(projectId);

const routerUnitPrice = getUnitPrice(
  "interface",
  currency
);

const virtualAccount = useSelector(
  (state) => state.user.virtualAccount
);

const walletBalance = virtualAccount
  ? Number(
      currency === "USD"
        ? virtualAccount?.dollar_balance
        : virtualAccount?.balance
    )
  : null;
  
const [
  showPaymentModal,
  setShowPaymentModal,
] = useState(false);

const calculateRouterCost = (
  paymentMode
) => {
  if (
    !paymentMode ||
    routerUnitPrice == null
  ) {
    return {
      numeric: 0,
      formatted: "Price unavailable",
    };
  }

  const totalCost =
    paymentMode === "yearly"
      ? routerUnitPrice * 12
      : routerUnitPrice;

  return {
    numeric: totalCost,
    formatted:
      totalCost.toLocaleString(
        "en-US",
        {
          style: "currency",
          currency:
            currency === "NGN"
              ? "NGN"
              : "USD",
        }
      ),
  };
};

  const showManageRouterModal = (key, data) => {
    setManageRouterModal(key);
    const routerDetails = {
      routerId: data.id,
      routerName: data.name,
      subnetId: data.subnetId,
    };
    sessionStorage.setItem("selectedRouter", JSON.stringify(routerDetails));
  };

  const closeManageRouterModal = () => {
    setManageRouterModal(false);
  };

  const toggleRouterModal = () => {
    setRouterModal(!routerModal);
  };

  const toggleEditRouterModal = (router) => {
    setSelectedRouter(router);
    setEditRouterModal(!editRouterModal);
  };

  const showRouterDetailsModal = (router) => {
    setSelectedRouter(router);
    setRouterDetailsModal(true);
  };

  const closeRouterDetailsModal = () => {
    setRouterDetailsModal(false);
    setSelectedRouter(null);
  };

  useEffect(() => {
    if (currency === "NGN") {
      setCurrencyPTag("₦");
    }
    if (currency === "USD") {
      setCurrencyPTag("$");
    }
  }, [currency]);

  const handleSearchChange = (event) => {
    setSearchText(event.target.value);
    setCurrentPage(1);
  };

  const options = [
    { value: "all-routers", label: "All routers" },
    { value: "name", label: "Router Name" },
  ];

  const routerList = useRouterList(projectId);

  

  const routerListMap = Array.isArray(routerList)
    ? routerList.map((router) => ({
        name:
          router.name && router.name.trim() !== ""
            ? router.name
            : "Default Router",
        status: router.status,
        external: router?.external_gateway_info?.enable_snat ? "Yes" : "No",
        subnetId:
          router?.external_gateway_info?.external_fixed_ips &&
          router?.external_gateway_info?.external_fixed_ips.length > 0
            ? (router?.external_gateway_info?.external_fixed_ips[0].subnet_id ??
              "N/A")
            : "N/A",
        adminState: router.admin_state_up ? "UP" : "DOWN",
        id: router.id,
        description: router?.description,
        zones:
          router.availability_zones && router.availability_zones.length > 0
            ? (router.availability_zones[0] ?? "N/A")
            : "N/A",
        createdAt: FormatDate(router.created_at),
      }))
    : [];

  const overviewDetails = selectedRouter
    ? [
        {
          title: "Name",
          value: selectedRouter?.name || "N/A",
        },
        {
          title: "Router ID",
          value: selectedRouter?.id || "N/A",
        },
        {
          title: "Project ID",
          value: selectedRouter?.project_id || "N/A",
        },
        {
          title: "Status",
          value: selectedRouter?.status || "N/A",
        },
        {
          title: "Admin State",
          value: selectedRouter?.admin_state_up ? "UP" : "DOWN",
        },
        {
          title: "Availability Zones",
          value:
            selectedRouter?.availability_zones?.length > 0
              ? selectedRouter.availability_zones.join(", ")
              : "N/A",
        },
      ]
    : [];

  const overviewExternalGatewayDetails = selectedRouter
    ? [
        {
          title: "External Network ID",
          value: selectedRouter?.external_gateway_info?.network_id || "N/A",
        },
        {
          title: "External Fixed IPs",
          value:
            selectedRouter?.external_gateway_info?.external_fixed_ips?.length >
            0
              ? selectedRouter.external_gateway_info.external_fixed_ips
                  .map((ip) => `Subnet: ${ip.subnet_id}, IP: ${ip.ip_address}`)
                  .join("; ")
              : "N/A",
        },
        {
          title: "SNAT",
          value: selectedRouter?.external_gateway_info?.enable_snat
            ? "Enabled"
            : "Disabled",
        },
      ]
    : [];

  const [currentPage, setCurrentPage] = useState(1);
  const entriesPerPage = 5;

  const filteredData = routerListMap?.filter((row) =>
    row?.name?.toLowerCase().includes(searchText.toLowerCase())
  );

  const indexOfLastEntry = currentPage * entriesPerPage;
  const indexOfFirstEntry = indexOfLastEntry - entriesPerPage;
  const currentEntries = filteredData.slice(
    indexOfFirstEntry,
    indexOfLastEntry
  );
  const totalPages = Math.ceil(filteredData.length / entriesPerPage);

  const handlePreviousPage = () => {
    if (currentPage > 1) {
      setCurrentPage(currentPage - 1);
    }
  };

  const handleNextPage = () => {
    if (currentPage < totalPages) {
      setCurrentPage(currentPage + 1);
    }
  };

 const submitRouterCreation = async (
  values
) => {
  const {
    routerName,
    description,
    paymentMode,
  } = values;

  const routerData = {
    name: routerName,
    description,
    projectId,
    payment_mode: paymentMode,
  };

  const { payload } = await dispatch(
    createProjectRouters(routerData)
  );

  if (
    payload?.statuscode === "00"
  ) {
    await dispatch(
      projectRouterList(projectId)
    );

    setShowPaymentModal(false);
    setRouterModal(false);

    window.location.reload();
  } else {
    toast.error(
      `Failed to create router: ${
        payload?.message ||
        payload?.statusmessage ||
        "Unknown error"
      }`
    );
  }
};

const createRouter = useFormik({
  initialValues: {
    routerName: "",
    description: "",
    paymentMode: "monthly",
  },

  validationSchema: Yup.object({
    routerName:
      Yup.string().required(
        "Name is required"
      ),

    description:
      Yup.string().required(
        "Description is required"
      ),

    paymentMode:
      Yup.string().required(
        "Payment Method is required"
      ),
  }),

  onSubmit: async (values) => {
    if (
      routerUnitPrice == null
    ) {
      toast.error(
        "Unable to retrieve the router price for this zone."
      );

      return;
    }

    if (
      walletBalance === null ||
      Number.isNaN(walletBalance)
    ) {
      toast.error(
        "Unable to retrieve your wallet balance. Please try again."
      );

      return;
    }

    const totalCost =
      calculateRouterCost(
        values.paymentMode
      ).numeric;

    if (
      totalCost > walletBalance
    ) {
      setShowPaymentModal(true);
      return;
    }

    await submitRouterCreation(
      values
    );
  },
});

  const editRouter = useFormik({
    initialValues: {
      routerName: selectedRouter?.name || "",
      description: selectedRouter?.description || "",
    },

    enableReinitialize: true,
    validationSchema: Yup.object({
      routerName: Yup.string().required("Name is required"),
      // description: Yup.string().required("Description is required"),
    }),

    onSubmit: async (values) => {
      const { routerName, description } = values;

      const routerData = {
        routerId: selectedRouter.id,
        name: routerName,
        // description,
        projectId,
      };

      const { payload } = await dispatch(updateProjectRouter(routerData));
      if (payload.statuscode === "00") {
        await dispatch(projectRouterList(projectId));
        setEditRouterModal(false);
        window.location.reload();
      }
    },
  });

  const handleServerAction = async (action, routerId) => {
    const { payload } = await dispatch(action({ projectId, routerId }));

    if (payload.statuscode === "00") {
      window.location.reload();
    }
  };

  const deleteRouter = (routerId) =>
    handleServerAction(deleteProjectRouter, routerId);

  const handleRedirectToDetails = (index, row) => {
    showManageRouterModal(index, row);
    navigate("/routers/router-details");
  };

  return (
    <div className="min-h-screen px-4 md:px-10 pt-6 pb-10 dark:text-white">
      <p className="crimson-font text-xl font-medium text-primaryBlue">
        Manage your routers
      </p>

      {routerList?.length > 0 ? (
        <div>
          <div className="w-full flex justify-between items-center gap-4 lg:flex-row flex-col mb-10">
            <div className="w-full md:w-[initial] grid grid-cols-1 md:grid-cols-12 gap-4 items-end my-10">
              <div className="md:col-span-3">
                <Select
                  label="Filter routers"
                  name="routers"
                  options={options}
                />
              </div>
              <div className="md:col-span-4">
                <input
                  type="search"
                  name=""
                  value={searchText}
                  onChange={handleSearchChange}
                  placeholder="Search for router..."
                  className="bg-white text-black w-full p-4 text-sm rounded-md border border-[#c4c4c460] active:outline-0 focus:outline-0 placeholder:opacity-70 placeholder:text-xs dark:bg-slate-800 dark:text-white"
                />
              </div>
            </div>

            <div
              className="px-4 py-3 text-xs border-[1.5px] border-primaryBlue rounded-md text-primaryBlue cursor-pointer w-fit"
              onClick={toggleRouterModal}
            >
              Create router
            </div>
          </div>

          <div className="overflow-x-auto rounded-md border dark:border-[#c4c4c432]">
            <table className="w-full text-sm text-left overflow-hidden">
              <thead className="bg-white dark:bg-slate-800 px-3 md:px-4 border text-gray-400 dark:border-[#c4c4c432] border-b text-sm font-semibold">
                <tr>
                  <th scope="col" className="px-6 py-4 whitespace-nowrap w-5">
                    #
                  </th>
                  <th
                    scope="col"
                    className="px-6 py-4 whitespace-nowrap max-w-52"
                  >
                    Router name
                  </th>
                  <th scope="col" className="px-6 py-4 whitespace-nowrap">
                    External Network
                  </th>
                  <th scope="col" className="px-6 py-4 whitespace-nowrap">
                    Admin State
                  </th>
                  {/* <th scope="col" className="px-6 py-4 whitespace-nowrap">
                        Availability Zones
                    </th> */}
                  <th scope="col" className="px-6 py-4 whitespace-nowrap">
                    Status
                  </th>
                  <th scope="col" className="px-6 py-4 whitespace-nowrap">
                    Actions
                  </th>
                </tr>
              </thead>
              <tbody className="bg-white dark:bg-slate-800 px-3 md:px-4 border rounded-b-md dark:border-[#c4c4c432] border-t-2 text-sm">
                {currentEntries.map((row, index) => (
                  <tr
                    key={index}
                    className="dark:hover:bg-[#ffffff05] hover:bg-brandBlue/25 whitespace-nowrap"
                  >
                    <td className="text-start py-4 px-6">{index + 1}.</td>
                    <td
                      className="text-start py-4 px-6 text-primaryBlue hover:underline cursor-pointer"
                      // onClick={() => showRouterDetailsModal(routerList.find((r) => r.id === row.id))}
                      onClick={() => handleRedirectToDetails(index, row)}
                    >
                      {row.name}
                    </td>
                    <td className="text-start py-4 px-6">{row.external}</td>
                    <td className="text-start py-4 px-6">{row.adminState}</td>
                    {/* <td className="text-start py-4 px-6">{row.zones}</td> */}
                    <td className="text-start py-4 px-6">{row.status}</td>
                    <td className="text-start py-4 px-6">
                      <button
                        className="text-white p-3 text-xs rounded bg-primaryBlue w-full md:w-fit"
                        onClick={() => showManageRouterModal(index, row)}
                      >
                        Manage Router
                      </button>

                      {manageRouterModal === index && (
                        <div className="w-full fixed h-screen bg-black/70 top-0 left-0 px-4 flex items-end md:items-center justify-center z-50">
                          <div className="bg-white dark:bg-[#141D26] rounded w-full md:w-[30%] dark:text-white max-h-[80%] mb-4 md:mb-0 overflow-auto">
                            <div className="flex justify-between items-center text-sm p-6 border-b dark:border-b-[#c4c4c432]">
                              <div className="flex gap-2 items-center">
                                <span className="dark:text-white">
                                  Manage "{row.name}"
                                </span>
                              </div>
                              <img
                                src={close}
                                onClick={closeManageRouterModal}
                                className="h-5 cursor-pointer"
                                alt=""
                              />
                            </div>
                            <div className="p-4 grid gap-1">
                              <Link
                                to={generatePartnerUrl("/routers/router-details")}
                                className="flex items-center justify-between hover:rounded border-b dark:border-[#c4c4c424] last:border-none py-4 px-3 hover:bg-primaryBlue/5 transition-all"
                              >
                                <span>View Router Details</span>
                                <span>
                                  <img src={arrow} alt="" className="" />
                                </span>
                              </Link>

                              <div
                                className="flex items-center justify-between hover:rounded border-b dark:border-[#c4c4c424] last:border-none py-4 px-3 hover:bg-primaryBlue/5 transition-all cursor-pointer"
                                onClick={() => toggleEditRouterModal(row)}
                              >
                                <span>Edit router</span>
                                <span>
                                  <img src={arrow} alt="" className="" />
                                </span>
                              </div>

                              <div
                                className="flex justify-self-center text-red-500 rounded-md py-5 px-3 text-center cursor-pointer"
                                onClick={() => {
                                  setDeleteRouterModal(true);
                                }}
                              >
                                <span className="hover:underline">
                                  Delete router
                                </span>
                              </div>
                            </div>

                            <Modal
                              title={"Delete Router"}
                              isVisible={deleteRouterModal}
                              onClose={() => setDeleteRouterModal(false)}
                            >
                              <div className="text-sm text-center pt-6 text-wrap">
                                Are you sure you want to delete{" "}
                                <span className="underline">{row.name}</span> .
                                This action cannot be undone.
                              </div>
                              <div className="grid gap-4 justify-center py-6">
                                <button
                                  className="bg-red-500 text-white text-xs px-6 py-4 rounded-sm w-fit"
                                  onClick={() => deleteRouter(row.id)}
                                >
                                  Yes, delete {row.name}
                                </button>
                                <button
                                  className="text-[#1DA1F2] text-sm px-6 py-2 hover:underline"
                                  onClick={() => setDeleteRouterModal(false)}
                                >
                                  Cancel
                                </button>
                              </div>
                            </Modal>
                          </div>
                        </div>
                      )}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
          <div className="grid justify-center gap-4 md:flex md:justify-between items-center mt-4">
            <p className="text-gray-400 text-sm">
              Showing{" "}
              <span className="font-medium text-black dark:text-white">
                {indexOfFirstEntry + 1}
              </span>{" "}
              to{" "}
              <span className="font-medium text-black dark:text-white">
                {Math.min(indexOfLastEntry, routerListMap?.length)}
              </span>{" "}
              of{" "}
              <span className="font-medium text-black dark:text-white">
                {routerListMap?.length}
              </span>{" "}
              results
            </p>
            <div className=" flex gap-3">
              <button
                className={`bg-white dark:bg-primaryBlue border dark:border-none rounded-md py-3 px-5 text-sm ${currentPage === 1 ? "opacity-50" : "opacity-100"}`}
                onClick={handlePreviousPage}
                disabled={currentPage === 1}
              >
                Previous
              </button>
              <button
                className={`bg-white dark:bg-primaryBlue border dark:border-none rounded-md py-3 px-5 text-sm ${currentPage === totalPages ? "opacity-50" : "opacity-100"}`}
                onClick={handleNextPage}
                disabled={currentPage === totalPages}
              >
                Next
              </button>
            </div>
          </div>
        </div>
      ) : (
        <>
          <div className="md:px-52 text-center grid text-gray-500 mt-32">
            <div>
              It looks like you don't have a networks yet. Once you create a
              router, your router details will appear here.
            </div>
            <div
              className="border border-[#c4c4c450] dark:border-[#c4c4c416] rounded-md p-3 flex items-center justify-self-center mt-8 w-fit text-xs cursor-pointer"
              onClick={toggleRouterModal}
            >
              <span>Create Router</span>
              <span className="ps-2">
                <img src={arrow} alt="" />
              </span>
            </div>
          </div>
        </>
      )}

      {/* router modal */}
      {routerModal && (
        <div className="fixed top-0 h-screen w-full left-0 z-50 bg-black/60 flex items-center justify-center p-4">
          <div className="bg-white dark:bg-[#141D26] rounded-md p-4 md:p-10 w-full md:w-1/3 max-h-[80%] overflow-y-scroll">
            <div className="flex items-center justify-between mb-4">
              <p className="text-primaryBlue">Create a router</p>
              <span onClick={toggleRouterModal} className="cursor-pointer">
                <img alt="" src={close} className="h-5" />
              </span>
            </div>

            <form className="gap-y-6 grid" onSubmit={createRouter.handleSubmit}>
              <Input
                label={"Router name"}
                type={"text"}
                name={"routerName"}
                value={createRouter.values.routerName}
                onBlur={createRouter.handleBlur}
                onChange={createRouter.handleChange}
                onError={
                  createRouter.errors.routerName &&
                  createRouter.touched.routerName
                    ? createRouter.errors.routerName
                    : null
                }
              />

              <TextArea
                label={"Description"}
                type={"text"}
                name={"description"}
                value={createRouter.values.description}
                onBlur={createRouter.handleBlur}
                onChange={createRouter.handleChange}
                onError={
                  createRouter.errors.description &&
                  createRouter.touched.description
                    ? createRouter.errors.description
                    : null
                }
              />
              <Select
        label="Payment Method"
        type="text"
        name="paymentMode"
        options={[
          {
            label:
              "Select payment method",
            value: "",
          },
          {
            label: "Monthly",
            value: "monthly",
          },
          {
            label: "Yearly",
            value: "yearly",
          },
        ]}
        placeholder="Select payment method"
        value={
          createRouter.values.paymentMode
        }
        onBlur={
          createRouter.handleBlur
        }
        onChange={
          createRouter.handleChange
        }
        onError={
          createRouter.errors
            .paymentMode &&
          createRouter.touched
            .paymentMode
            ? createRouter.errors
                .paymentMode
            : null
        }
      />

      {createRouter.values
        .paymentMode && (
        <div className="grid gap-2">
          <div className="text-xs">
            Estimated cost:
          </div>

          <div className="font-semibold crimson-font text-primaryBlue text-lg">
            {
              calculateRouterCost(
                createRouter.values
                  .paymentMode
              ).formatted
            }
          </div>
        </div>
      )}

              <div className="flex justify-between items-center gap-2">
               <Button
            buttonText={
              unitPriceLoading
                ? "Loading price..."
                : walletBalance !== null &&
                    calculateRouterCost(
                      createRouter.values
                        .paymentMode
                    ).numeric >
                      walletBalance
                  ? "Pay Now"
                  : "Create Router"
            }
            buttonRole="submit"
            type="submit"
            disabled={
              unitPriceLoading ||
              routerUnitPrice == null
            }
          />
              </div>
            </form>
          </div>
        </div>
      )}

      <PaymentModal
  isOpen={showPaymentModal}
  onClose={() =>
    setShowPaymentModal(false)
  }
  currency={currency}
  totalPrice={
    calculateRouterCost(
      createRouter.values
        .paymentMode
    ).numeric
  }
  walletBalance={
    walletBalance || 0
  }
  virtualAccount={
    virtualAccount
  }
  onPaymentSuccess={() =>
    submitRouterCreation(
      createRouter.values
    )
  }
/>

      {/* Edit Router Modal */}
      {editRouterModal && selectedRouter && (
        <div className="fixed top-0 h-screen w-full left-0 z-50 bg-black/60 flex items-center justify-center p-4">
          <div className="bg-white dark:bg-[#141D26] rounded-md p-4 md:p-10 w-full md:w-1/3 max-h-[80%] overflow-y-scroll">
            <div className="flex items-center justify-between mb-4">
              <p className="text-primaryBlue">
                Edit Router "{selectedRouter?.name}"
              </p>
              <span
                onClick={() => toggleEditRouterModal(null)}
                className="cursor-pointer"
              >
                <img alt="" src={close} className="h-5" />
              </span>
            </div>

            <form className="gap-y-6 grid" onSubmit={editRouter.handleSubmit}>
              <Input
                label={"Router name"}
                type={"text"}
                name={"routerName"}
                value={editRouter.values.routerName}
                onBlur={editRouter.handleBlur}
                onChange={editRouter.handleChange}
                onError={
                  editRouter.errors.routerName && editRouter.touched.routerName
                    ? editRouter.errors.routerName
                    : null
                }
              />

              <TextArea
                label={"Description"}
                type={"text"}
                name={"description"}
                value={editRouter.values.description}
                onBlur={editRouter.handleBlur}
                onChange={editRouter.handleChange}
                onError={
                  editRouter.errors.description &&
                  editRouter.touched.description
                    ? editRouter.errors.description
                    : null
                }
              />

              <div className="flex justify-between items-center gap-2">
                <Button buttonText={"Update Router"} buttonRole={"submit"} />
              </div>
            </form>
          </div>
        </div>
      )}

      {/* Router Details Modal */}
      {routerDetailsModal && selectedRouter && (
        <div className="fixed w-full bg-black/60 top-0 left-0 z-50 h-screen">
          <div className="w-full flex h-full items-center justify-center p-4">
            <div className="bg-white dark:bg-[#141D26] dark:text-white w-full md:w-[80%] rounded h-full overflow-y-auto">
              <div className="px-6 md:px-10 py-6 border-b dark:border-b-[#c4c4c432] flex justify-between items-center">
                <span className="text-primaryBlue font-medium">
                  Router Information:
                </span>
                <span
                  onClick={closeRouterDetailsModal}
                  className="cursor-pointer"
                >
                  <img src={close} alt="Close" className="h-5" />
                </span>
              </div>

              <div className="py-10 grid gap-6 px-6">
                <div className="w-full flex flex-col items-start gap-4">
                  <h4 className="w-full text-black dark:text-white text-lg mb-4 border-b border-gray-400 pb-2">
                    Router Overview:
                  </h4>

                  <div className="w-full grid grid-cols-1 md:grid-cols-2 gap-6">
                    {overviewDetails.map((detail, index) => (
                      <div
                        key={index}
                        className="w-full flex flex-col items-start"
                      >
                        <h4 className="text-black dark:text-white text-lg">
                          {detail.title}:
                        </h4>
                        <h4 className="text-gray-800 dark:text-gray-200 font-semibold text-xl">
                          {detail.title === "Status" ? (
                            detail.value === "ACTIVE" ? (
                              <div className="flex gap-1 items-center bg-emerald-500 text-white py-2 px-6 rounded-md">
                                <span>Active</span>
                              </div>
                            ) : (
                              <div className="flex gap-1 items-center bg-red-600 text-white py-2 px-6 rounded-md">
                                <span>{detail.value}</span>
                              </div>
                            )
                          ) : (
                            detail.value
                          )}
                        </h4>
                      </div>
                    ))}
                  </div>
                </div>

                <div className="w-full flex flex-col items-start gap-4">
                  <h4 className="w-full text-black dark:text-white text-lg mb-4 border-b border-gray-400 pb-2">
                    External Gateway Information:
                  </h4>

                  <div className="w-full grid grid-cols-1 md:grid-cols-2 gap-6">
                    {overviewExternalGatewayDetails.map((detail, index) => (
                      <div
                        key={index}
                        className="w-full flex flex-col items-start"
                      >
                        <h4 className="text-black dark:text-white text-lg">
                          {detail.title}:
                        </h4>
                        <h4 className="text-gray-800 dark:text-gray-200 font-semibold text-xl">
                          {detail.value}
                        </h4>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Routers;
